import Base from '../Pages/Base'
import List from '../Pages/List'
import Form from '../Pages/Form'

export default [
	{
		path: 'admin/condicoes',
		component: Base,
		children: [
			{
				path: '',
				name: 'CondicoesList',
				component: List,
				meta: {
					path: '/admin/condicoes',
					pai: 'Admin',
					title: 'siS - Condições',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Condições',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			{
				path: 'novo',
				name: 'CondicoesNovo',
				component: Form,
				meta: {
					path: '/admin/condicoes',
					pai: 'Admin',
					title: 'siS - Condições - Novo',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Condições',
						class: '',
						active: false,
						url: '/admin/condicoes'
					},
					{
						pagina: 'Novo',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			{
				path: ':id',
				name: 'CondicoesEditar',
				component: Form,
				meta: {
					path: '/admin/condicoes',
					pai: 'Admin',
					title: 'siS - Condições - Editar',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Condições',
						class: '',
						active: false,
						url: '/admin/condicoes'
					},
					{
						pagina: 'Editar',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			}
		]
	}
]